const essayErasingLogWordsMaxLimit = 15;
const essayErasingLogWordsMinLimit = 3;

const logService = {
    essayErasingLogged: {},

    logEssayErasing(ckeditor, contentRevisionId) {
        if (!ckeditor || !contentRevisionId) {
            return;
        }

        const lastWordCount = ckeditor.wordCount?.wordCount;
        if (lastWordCount > essayErasingLogWordsMaxLimit) {
            this.essayErasingLogged[contentRevisionId] = false;

            setTimeout(() => {
                if (this.essayErasingLogged[contentRevisionId]) {
                    return;
                }

                const updatedWordCount = ckeditor?.wordCount?.wordCount;
                if (!isNaN(updatedWordCount) && updatedWordCount <= essayErasingLogWordsMinLimit) {
                    const change = `Word count changed from ${lastWordCount} to ${updatedWordCount}`;
                    console.warn(`Saving erased essay content, contentRevisionId: ${contentRevisionId}. ${change}`);
                    this.essayErasingLogged[contentRevisionId] = true;
                }
            }, 1000);
        }
    },
};

export default logService;
